import crypto from "crypto";

export const hashWord = (word) => {
  return crypto.createHash('sha256').update(word).digest('hex');
};

export const checkHashWord = (inputWord, hash) => {
  return hashWord(inputWord) === hash;
};